export const SET_DISABLED = 'setDisabled';
export const SET_TIPO_GESTION = 'set_tipo_gestion';
export const RESET = 'reset';
export const INIT = 'init';
export const SET_DIAS = 'set_dias';
